import { PropsWithChildren } from 'react'
import { QuestionMarkIcon } from '@systemeio/ui'

type WebhookFormTitleProps = PropsWithChildren

const WebhookFormTitle = ({ children }: WebhookFormTitleProps) => (
  <div
    className={
      'bg-brand-primary-subtle text-text-primary flex items-center gap-5 px-6 py-3 text-base font-bold'
    }
  >
    <QuestionMarkIcon className="fill-brand-primary" />
    {children}
  </div>
)

export default WebhookFormTitle
